@if (loadingService.isLoading()) {
  <div class="loading-overlay">
    <div class="spinner-container">
      <l-ring size="60" stroke="5" bg-opacity="0" speed="2" color="white">
      </l-ring>
    </div>
  </div>
}
